export default __webpack_public_path__ + "static/ring2-a9636050fbd73825da4d95d0cb3ef593.png";